<div *ngIf="show">
  <div class="alert alert-danger validation-div ">
    <div class="validation-title">Please correct the following:</div>
    <ul>
      <ng-container *ngFor="let error of errorList" >      
        <li class="validation-text" *ngIf="validError(error)"> 
          {{ error | validationToString }}
        </li>
      </ng-container>
    </ul>
  </div>
</div>
